import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SALES_PRODUCT_TAB_ITEMS } from "./SalesProductAnalyticsTabsDashboard.data";
import {
  useSalesProductDateRange,
  useSalesProductTab,
} from "../hooks/UseSalesProductUrlState";
import { OverviewSection } from "./SalesProductOverviewSection";
import { SalesSection } from "./SalesProductSalesSection";
import { InventorySection } from "./SalesProductInventorySection";
import { CustomersSection } from "./SalesProductCustomersSection";
import { AttributionSection } from "./SalesProductAttributionSection";
import "./SalesProductAnalyticsTabsDashboard.scss";

const SalesProductAnalyticsTabsDashboard: FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useSalesProductTab();
  const [dateRange, setDateRange] = useSalesProductDateRange();
  return (
    <div className="sales-product-analytics-dashboard">
      <div className="sales-product-analytics-dashboard__tabs">
        {SALES_PRODUCT_TAB_ITEMS.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={`sales-product-analytics-dashboard__tab ${activeTab === tab.id ? "sales-product-analytics-dashboard__tab--active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {t(`salesProduct.tabs.${tab.id}`, { defaultValue: tab.label })}
          </button>
        ))}
      </div>

      {activeTab === "overview" ? (
        <OverviewSection
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
      ) : null}
      {activeTab === "sales" ? (
        <SalesSection
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      ) : null}
      {activeTab === "inventory" ? (
        <InventorySection dateRange={dateRange} />
      ) : null}
      {activeTab === "customers" ? (
        <CustomersSection
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      ) : null}
      {activeTab === "attribution" ? (
        <AttributionSection
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      ) : null}
    </div>
  );
};

export default SalesProductAnalyticsTabsDashboard;